import React, { InputHTMLAttributes, useRef, useState } from "react";
import styled from "styled-components";
import Typography from "../typography";
import { Colors } from "../../utils/colors";

interface IProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  status?: string; //error
  disabled?: boolean;
  height?: string;
  width?: string;
  limit?: number;
}
const TextArea = ({
  label,
  required,
  status = "default",
  disabled,
  height,
  width = "100%",
  limit,
  ...rest
}: IProps) => {
  const [focused, setFocused] = useState(false);
  let ref = useRef<HTMLTextAreaElement>(null);
  return (
    <Container>
      {label && (
        <Typography color="#CDCDCD" weight="medium" mb="0.4" align="left">
          {label}
          {required && "*"}
        </Typography>
      )}
      <InputContainer status={status} focused={focused ? "true" : "false"}>
        <Input
          maxLength={limit}
          status={status}
          {...rest}
          onFocus={() => {
            setFocused(true);
          }}
          ref={ref}
          disabled={disabled}
          onBlur={() => setFocused(false)}
          style={{ height: height, width: width }}
        />
        {disabled && (
          <DisabledDiv>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M1 8C1 6.5858 1 5.8787 1.43934 5.43935C1.87868 5 2.58579 5 4 5H8C9.4142 5 10.1213 5 10.5606 5.43935C11 5.8787 11 6.5858 11 8C11 9.4142 11 10.1213 10.5606 10.5606C10.1213 11 9.4142 11 8 11H4C2.58579 11 1.87868 11 1.43934 10.5606C1 10.1213 1 9.4142 1 8Z"
                stroke="#131313"
                stroke-width="0.75"
              />
              <path
                d="M6 9C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9Z"
                stroke="#131313"
                stroke-width="0.75"
              />
              <path
                d="M3 5V4C3 2.34315 4.34315 1 6 1C7.65685 1 9 2.34315 9 4V5"
                stroke="#131313"
                stroke-width="0.75"
                stroke-linecap="round"
              />
            </svg>
          </DisabledDiv>
        )}
      </InputContainer>
      {limit ? (
        <Typography size="xs" color={Colors.grey500} mt="0.3">
          {ref.current?.value.length}/{limit} Characters
        </Typography>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default TextArea;

const Container = styled.div`
  position: relative;
`;

const InputContainer = styled.div<{ status?: string; focused?: string }>`
  width: 100%;
  padding: 1rem;
  border: 1px solid
    ${(props) =>
      props.focused === "true"
        ? Colors.primary
        : props.status === "error"
        ? Colors.danger
        : Colors.grey500};
  border-radius: 0.8rem;
  transition: ease all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Input = styled.textarea<{ status?: string }>`
  font-family: "Switzer", sans-serif;
  width: 90%;
  outline: none;
  background: none;
  border: none;
  color: ${Colors.white200};
  font-family: "Inter", sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
  resize: none;
  &::placeholder {
    color: ${Colors.grey500};
  }
`;

const DisabledDiv = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #fed998;
  align-items: center;
  justify-content: center;
  display: flex;
`;
